<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">The author and publishers would like to point out that any resemblance to persons living or dead is purely accidental and non-intentional.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frm.vue?19d6c0d6